var map = {
	"./center-blue.svg": "Yd4W",
	"./left-blue.svg": "qAKv",
	"./right-blue.svg": "Wlcp"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "Ry5+";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon/column-alignment ^\.\/.*\-blue\.svg$
// module id = Ry5+
// module chunks = 46